import { BooksDTO, newBookDTO } from "../dto/BooksDTO";
import { FetchAuth } from "../utils/FetchAuthUtil";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class BooksService {
    public static getBooks = async ( limit: number, page: number, archived: boolean | null, published: boolean | null, title: string | null,sortColumn?:string|null,sortDirection?:string): Promise<any> => {
        try {
            const params = new URLSearchParams({
                page: String(page),
                limit: String(limit),
                ...(archived !== null && { archived: String(archived) }),
                ...(published !== null && { published: String(published) }),
                ...(title && { title })
            });

            if (sortColumn && sortDirection) {
                params.append('sort', `${sortColumn}:${sortDirection}`);
            }
            const resp = await FetchAuth(`${endpoint}/book/adminGetBooks?${params.toString()}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });

            return await resp.json();
        } catch (error) {
            throw error;
        }
    }

    // Get an authenticated, one-time preview link for a book. Streams through the
    // backend proxy (works for private DO Spaces objects); avoids the raw mobileUrl
    // which 403s for any book uploaded after books were switched to ACL: private.
    public static previewBook = async (bookId: string): Promise<string> => {
        try {
            const resp = await FetchAuth(`${endpoint}/books/${bookId}/admin-preview-link`, {
                method: "POST",
                headers: { "Content-Type": "application/json" }
            });
            const data = await resp.json();
            return data.link;
        } catch (error) {
            throw error;
        }
    }

    public static getBooksByPublisher = async ( id: string | null): Promise<BooksDTO[]> => {
        try {
            const params = new URLSearchParams({
                page: String(1),
                limit: String(10000),
                ...(id&&{publisherId:id})
            });

            const resp = await FetchAuth(`${endpoint}/book/adminGetBooks?${params.toString()}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });


            const result=await resp.json();
            return result.books;
        } catch (error) {
            throw error;
        }
    }

    public static getBookById = async ( _id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(`${endpoint}/book/getBookDetails/${_id}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });

            return await resp.json();
        } catch (error) {
            throw error;
        }
    }


   

    public static getFileAccessCode = async ( format: "excel" | "csv" | "pdf",batchId?:string): Promise<Blob> => {
        try {
            const resp = await FetchAuth(`${endpoint}/admin/exportAccessCodes/${batchId}?format=${format}`, {
                method: 'GET',
                headers: { "Content-Type": "application/json" }
            });

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    }

    public static togglePublish = async ( id: string): Promise<string> => {
        try {
            const resp = await FetchAuth(`${endpoint}/book/togglePublish/${id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': "application/json" }
            });

       
            const data = await resp.json();
            return data.message;
        } catch (error) {
            throw error;
        }
    }

    public static toggleArchive = async ( id: string): Promise<string> => {
        try {
            const resp = await FetchAuth(`${endpoint}/book/toggleArchive/${id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': "application/json" }
            });


            const data = await resp.json();
            return data.message;
        } catch (error) {
            throw error;
        }
    }

    public static deleteBook = async ( id: string): Promise<string> => {
        try {
            const resp = await FetchAuth(`${endpoint}/book/deleteBook/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': "application/json" }
            });

        

            const data = await resp.json();
            return data.message;
        } catch (error) {
            throw error;
        }
    }

    public static getFile = async ( format: "excel" | "csv" | "pdf"): Promise<Blob> => {
        try {
            const resp = await FetchAuth(`${endpoint}/admin/exportBooks?format=${format}`, {
                method: 'GET',
                headers: { "Content-Type": "application/json" }
            });

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    }
    
    public static getTopFile = async ( format: "excel" | "csv",bookId:string,year:string,batchId?:string): Promise<Blob> => {
        try {
            if(batchId){
                const resp = await FetchAuth(`${endpoint}/admin/exportAnalyticsBatchBook/analytics/book/${bookId}/batch/${batchId}/yearly/export?year=${year}&fileType=${format}`, {
                    method: 'GET',
                    headers: { "Content-Type": "application/json" }
                });
    
            
    
                return await resp.blob();
            }else{
                const resp = await FetchAuth(`${endpoint}/admin/exportAnalytics/analytics/book/${bookId}/yearly/export?year=${year}&fileType=${format}`, {
                    method: 'GET',
                    headers: { "Content-Type": "application/json" }
                });
    
            
    
                return await resp.blob();

            }
            
        } catch (error) {
            throw error;
        }
    }

    public static getTopFileWebsite = async ( format: "excel" | "csv",bookId:string,year:string,batchId?:string): Promise<Blob> => {
        try {
            if(batchId){
                const resp = await FetchAuth(`${endpoint}/admin/exportAnalyticsBatchBook/analytics/book/${bookId}/batch/${batchId}/yearly/export?year=${year}&fileType=${format}`, {
                    method: 'GET',
                    headers: { "Content-Type": "application/json" }
                });
    
            
    
                return await resp.blob();
            }else{
                const resp = await FetchAuth(`${endpoint}/admin/exportAnalyticsOnline/analytics/book/${bookId}/yearly/export?year=${year}&fileType=${format}`, {
                    method: 'GET',
                    headers: { "Content-Type": "application/json" }
                });
    
            
    
                return await resp.blob();

            }
            
        } catch (error) {
            throw error;
        }
    }
    
    public static getTopDownloadedFile = async ( format: "excel" | "csv",exportType:string,categoryId?:string,publisherId?:string): Promise<Blob> => {
        try {
            const params = new URLSearchParams({
                fileType: format,
                ...(exportType !== undefined && { type: String(exportType) }),
                ...(publisherId !== undefined && { publisherId: String(publisherId) }),
                ...(categoryId !== undefined && { categoryId: String(categoryId) }),
            });
            const resp = await FetchAuth(`${endpoint}/admin/exportAnalyticsTopDownloaded/analytics/top-downloaded/export?${params.toString()}`, {
                method: 'GET',
                headers: { "Content-Type": "application/json" }
            });

        

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    }


    public static checkISBN = async ( isbn:string): Promise<any> => {
        try {
            const resp = await FetchAuth(`${endpoint}/book/checkIsbn`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ isbn })
            });
            const data= await resp.json();
            return data.isIsbnTaken
        } catch (error) {
            throw error;
        }
    }
}
